import React, { useState, useMemo, useEffect } from 'react';
import { Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Paper,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Alert,
} from '@mui/material';

import { register } from "../../actions/userActions"

const RegisterForm = (props) => {

  const dispatch = useDispatch()
  const [form, setForm] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    role: 'guest',

  });
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [submitActive, setSubmitActive] = useState(false)
  const userRegister = useSelector(state => state.userRegister)
  const userDetails = useSelector((state) => state.userDetails)
  const { user, success } = userDetails


  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      setErrorMessage("Passwords do not match")
      setSuccessMessage('')
    } else {
      dispatch(register(form, props.admin))
    }

  };



  const lengthPassMessage = useMemo(() => {
    if (form.password.length < 8) {
      return "Password must be at least 8 characters long"
    }
    else {
      return ""
    }
  }, [form.password,
  ])

  const characterPassMessage = useMemo(() => {
    if (! /[a-zA-Z]/.test(form.password)) {
      return "Password must contain at least one letter"
    }
    else {
      return ""
    }
  }, [form.password
  ])


  const digitsPassMessage = useMemo(() => {
    if (! /\d/.test(form.password)) {
      return "Password must contain at least one digit"
    }
    else {
      return ""
    }
  }, [form.password
  ])



  const englishPassMessage = useMemo(() => {
    if (/[^\x00-\x7F]/.test(form.password)) {
      return "Password must contain at least one letter"
    }
    else {
      return ""
    }
  }, [form.password
  ])

  useEffect(() => {

    if (form.password.length >= 8
      && /[a-zA-Z]/.test(form.password)
      && /\d/.test(form.password)
      && !/[^\x00-\x7F]/.test(form.password)
      && form.password === form.confirmPassword) {
      setSubmitActive(false)

    }
    else {
      setSubmitActive(true)

    }

  }, [form.password, form.confirmPassword]);

  useEffect(() => {
    if (userRegister.error) {
      if (userRegister.error.includes("UNIQUE constraint failed: users.email")) {
        setErrorMessage("Email already exists")
      }
      else if (userRegister.error.includes("UNIQUE constraint failed: users.username")) {
        setErrorMessage("Username already exists")
      }
      else {
        setErrorMessage(userRegister.error)

      }


    }
    else if (userRegister.success) {
      setSuccessMessage("Registration Successful!")
      setErrorMessage('')
      setForm({
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        role: 'guest',

      })

    }


  },

    [userRegister.error,
    userRegister.success
    ]
  )




  return (
    <>
     {(user.username && success && !props.admin) && <Navigate to="/" replace={true} />}
    
    <Container maxWidth="sm">
      <Box maxWidth="sm"
        sx={{
        }} >
        <Paper elevation={3} sx={{ p: 4, mt: 8, }}>
          <Typography variant="h5" component="h1" gutterBottom>
            {props.admin ?
              "Add User" :
              "Sign Up"}
          </Typography>
          <Box sx={{}} >
            {errorMessage && <Alert variant="filled"
              severity="error">{errorMessage}</Alert>}
            {successMessage && <Alert variant="filled"
              severity="success">{successMessage}</Alert>}
          </Box>
          <Typography
            sx={{ fontSize: "0.9em" }}
            display="block"
            color="error">
            {lengthPassMessage}
          </Typography>

          <Typography
            sx={{ fontSize: "0.9em" }}
            display="block"
            color="error">
            {digitsPassMessage}
          </Typography>

          <Typography
            sx={{ fontSize: "0.9em" }}
            display="block"
            color="error">
            {characterPassMessage}
          </Typography>

          <Typography
            sx={{ fontSize: "0.9em" }}
            display="block"
            color="error">
            {englishPassMessage}
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate>

            <TextField
              label="Username"
              name="username"
              value={form.username}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="First Name"
              name="firstName"
              type="text"
              value={form.firstName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Last Name"
              name="lastName"
              type="text"
              value={form.lastName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Enter Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Confirm Password"
              name="confirmPassword"
              type="password"
              value={form.confirmPassword}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            {props.admin ?
              <FormControl fullWidth margin="normal" required>
                <InputLabel id="role-label">Role</InputLabel>
                <Select
                  labelId="role-label"
                  name="role"
                  value={form.role}
                  onChange={handleChange}
                  label="Role"


                >
                  <MenuItem value="guest">Guest</MenuItem>
                  <MenuItem value="admin">Admin</MenuItem>
                </Select>
              </FormControl>
              :
              <></>}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 3 }}
              disabled={
                (!form.username ||
                  !form.firstName ||
                  !form.lastName ||
                  !form.email ||
                  !form.password ||
                  !form.confirmPassword) &&
                (submitActive)
              }
            >
              Register
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
    </>
  );
};

export default RegisterForm;
